class CourseTabs extends HTMLElement {
  connectedCallback() {
    this.tablist = this.querySelector('[role="tablist"]');
    this.panelsRoot = this.querySelector('.course-tabs__panels');
    if (!this.tablist || !this.panelsRoot) return;

    this.panels = Array.from(this.panelsRoot.querySelectorAll('[data-tab-label]'));
    if (!this.panels.length) return;

    this.tablist.setAttribute('aria-label', this.dataset.label || 'Course details');
    this.tabs = this.panels.map((panel, index) => {
      const id = panel.id || `course-tab-${index}`;
      panel.id = id;
      panel.setAttribute('role', 'tabpanel');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'course-tabs__tab';
      button.setAttribute('role', 'tab');
      button.dataset.tab = id;
      button.id = `tab-${id}`;
      button.setAttribute('aria-controls', id);
      button.textContent = panel.getAttribute('data-tab-label') || `Tab ${index + 1}`;
      panel.setAttribute('aria-labelledby', button.id);
      this.tablist.append(button);
      return button;
    });

    this.tablist.addEventListener('click', (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;
      this.select(tab.dataset.tab);
    });

    this.tablist.addEventListener('keydown', (event) => {
      const current = this.tabs.indexOf(document.activeElement);
      if (current < 0) return;
      let next = current;
      if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
      if (next === current) return;
      event.preventDefault();
      this.tabs[next].focus();
      this.select(this.tabs[next].dataset.tab);
    });

    const hash = window.location.hash.replace('#', '');
    const initial = this.tabs.find((tab) => tab.dataset.tab === hash) || this.tabs[0];
    this.select(initial.dataset.tab, false);

    this.querySelectorAll('.course-chip-group').forEach((group) => this.#setupChipGroup(group));
    this.querySelectorAll('.course-outcomes__more').forEach((button) => {
      button.addEventListener('click', () => {
        const body = button.previousElementSibling;
        body?.classList.remove('is-clamped');
        button.hidden = true;
      });
    });
  }

  select(id, updateHash = true) {
    this.tabs.forEach((tab) => {
      const on = tab.dataset.tab === id;
      tab.setAttribute('aria-selected', String(on));
      tab.tabIndex = on ? 0 : -1;
    });
    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== id;
    });
    const selected = this.tabs.find((tab) => tab.dataset.tab === id);
    if (selected) {
      const bar = this.tablist;
      const tabStart = selected.offsetLeft;
      const tabEnd = tabStart + selected.offsetWidth;
      if (tabStart < bar.scrollLeft) {
        bar.scrollTo({ left: tabStart, behavior: 'smooth' });
      } else if (tabEnd > bar.scrollLeft + bar.clientWidth) {
        bar.scrollTo({ left: tabEnd - bar.clientWidth, behavior: 'smooth' });
      }
    }
    if (updateHash) history.replaceState(null, '', `#${id}`);
  }

  #setupChipGroup(group) {
    const limit = Number(group.dataset.limit || 8);
    const chips = Array.from(group.querySelectorAll('.course-chip-group__list > *'));
    const button = group.querySelector('.course-chip-group__more');
    if (chips.length <= limit) {
      if (button) button.hidden = true;
      return;
    }
    group.classList.add('is-collapsed');
    chips.forEach((chip, index) => {
      if (index >= limit) chip.classList.add('is-overflow');
    });
    if (button) {
      button.hidden = false;
      button.addEventListener('click', () => {
        group.classList.remove('is-collapsed');
        button.hidden = true;
      });
    }
  }
}

if (!customElements.get('course-tabs')) {
  customElements.define('course-tabs', CourseTabs);
}
